<template>
  <div class="sidebar sidebar-light sidebar-main sidebar-fixed sidebar-expand-md">
    <!-- Sidebar content -->
    <div class="sidebar-content">
      <div class="card card-sidebar-mobile">
        <div class="card-body p-0" v-if="authStore.isAdmin">
          <ul class="nav nav-sidebar">
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.users.index' }" class="nav-link">
                <clients-icon/>
                <span>Vartotojai</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.promo.index' }" class="nav-link">
                <ppk-icon/>
                <span>Nuolaidos</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.api-key.index' }" class="nav-link">
                <unlock-icon/>
                <span>API raktai</span>
              </router-link>
              <ul class="nav nav-group-sub d-block">
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.api-calls.index' }" class="nav-link">
                    <span>API užklausos</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.referrals.index' }" class="nav-link">
                <database-icon/>
                <span>Referrals</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.feature-flags.index' }" class="nav-link">
                <expense-icon/>
                <span>Feature Flags</span>
              </router-link>
              <ul class="nav nav-group-sub d-block">
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.feature-flag-groups.index' }" class="nav-link">
                    <span>Feature Flag Groups</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.validation-logs.index' }" class="nav-link">
                <info-icon/>
                <span>Validation logs</span>
              </router-link>
              <ul class="nav nav-group-sub d-block">
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.eskola-errors.index' }" class="nav-link">
                    <span>Eskola Errors</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.export-logs.index' }" class="nav-link">
                <drawer-icon/>
                <span>Export Logs</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.voting-event.index' }" class="nav-link">
                <calendar-icon/>
                <span>Voting events</span>
              </router-link>
              <ul class="nav nav-group-sub d-block">
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.features.index' }" class="nav-link">
                    <span>Vote Features</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.new-users-statistics.index' }" class="nav-link">
                <increase-icon/>
                <span>Statistics</span>
              </router-link>
              <ul class="nav nav-group-sub d-block">
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.new-users-statistics.index' }" class="nav-link">
                    <span>New users</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.churned-users-statistics.index' }" class="nav-link">
                    <span>Churned Users</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.users-company-statistics.index' }" class="nav-link">
                    <span>Users Company Count</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{ name: 'admin.revenue-statistics.index' }" class="nav-link">
                    <span>Revenue</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.custom-referrals.index' }" class="nav-link">
                <ppk-icon/>
                <span>Custom Referrals</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.okredo-api.index' }" class="nav-link">
                <plug-icon/>
                <span>Okredo</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.subscription-events.index' }" class="nav-link">
                <database-icon/>
                <span>Subscription Events</span>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.admin_users.index' }" class="nav-link">
                <clients-icon/>
                <span>Admin Users</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClientsIcon from '@/components/icons/clients';
  import ExpenseIcon from '@/components/icons/expense';
  import PpkIcon from '@/components/icons/ppk';
  import gsap from 'gsap';
  import { addEventListener, removeEventListener, requestAnimationFrame } from '@/utils/browser';
  import UnlockIcon from '@/components/icons/unlock';
  import DatabaseIcon from '@/components/icons/database';
  import { useSidebarStore } from '@/stores/sidebar';
  import { useAuthStore } from '@/stores/auth';
  import InfoIcon from '@/components/icons/info.vue';
  import CalendarIcon from '@/components/icons/calendar.vue';
  import IncreaseIcon from '@/components/icons/increase-icon.vue';
  import PlugIcon from '@/components/icons/plug.vue';
  import DrawerIcon from '@/components/icons/drawer.vue';

  const ANIMATION_DURATION = 0.2;
  const SOLID_OPACITY = 0.65;
  const GUTTER = 15;
  const DIRECTION_THRESHOLD = 10;

  let touchStartX = 0;
  let touchStartY = 0;
  let distanceX = 0;
  let leftPosition = 0;
  let direction = 0;
  let raf = false;
  let width = 0;
  let endListenerBound = false;
  let moveListenerBound = false;

  const STATE = {
    CLOSED: 1,
    OPENING: 2,
    OPEN: 3,
    CLOSING: 4,
    PANNING: 5,
  };

  export default {
    name: 'FullSidebar',

    components: {
      DrawerIcon,
      PlugIcon,
      IncreaseIcon,
      CalendarIcon,
      InfoIcon,
      DatabaseIcon,
      UnlockIcon,
      PpkIcon,
      ClientsIcon, ExpenseIcon },

    data() {
      return {
        backdropEl: null,
        state: STATE.OPEN,
        sidebarStore: useSidebarStore(),
        authStore: useAuthStore(),
      };
    },

    computed: {
      mobileOpen() {
        return this.sidebarStore.mobileOpen;
      },
    },

    watch: {
      mobileOpen(newValue) {
        requestAnimationFrame(() => {
          if (newValue) {
            this._openSidebar();
          } else {
            this._closeSidebar();
          }
        });
      },
    },

    mounted() {
      this.backdropEl = document.getElementById('og-sidebar-backdrop');
      addEventListener(this.backdropEl, 'click', (event) => {
        event.stopImmediatePropagation();
        this._closeSidebar();
      });

      addEventListener(document, 'touchstart', this.touchStart, false);

      width = this.$el.offsetWidth;
    },

    created() {
      if (window.innerWidth >= 768) {
        this.state = STATE.OPEN;
      } else {
        this.state = STATE.CLOSED;
      }
    },

    beforeUnmount() {
      removeEventListener(document, 'touchstart', this.touchStart);
    },

    methods: {
      touchStart(event) {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        distanceX = 0;
        direction = null;

        if (this.state !== STATE.OPEN) {
          if (touchStartX > GUTTER) {
            return;
          }

          event.preventDefault();
        }

        requestAnimationFrame(() => {
          this.backdropEl.style.display = 'block';
          this.$el.classList.add('og-sidebar--has-touch');

          if (!moveListenerBound) {
            addEventListener(document, 'touchmove', this.touchMove, false);
            moveListenerBound = true;
          }

          raf = true;
        });
      },

      touchMove(event) {
        if (!raf) {
          return;
        }

        requestAnimationFrame(() => {
          distanceX = event.touches[0].clientX - touchStartX;
          const distanceY = event.touches[0].clientY - touchStartY;

          // determine move direction
          if (direction === null) {
            if (Math.abs(distanceX) > DIRECTION_THRESHOLD) {
              direction = 'x';
              leftPosition = parseInt(window.getComputedStyle(this.$el).getPropertyValue('left'));
            } else if (Math.abs(distanceY) > DIRECTION_THRESHOLD) {
              direction = 'y';
            }
          }

          if (direction === 'x') {
            if (!endListenerBound) {
              addEventListener(document, 'touchend', this.touchEnd);
              endListenerBound = true;
            }

            let moveDistance = Math.min(leftPosition - (distanceX * -1), 0);
            if (moveDistance < -width) {
              moveDistance = -width;
            }

            const distancePercentage = (width - Math.abs(moveDistance)) * 100 / width;
            const opacity = SOLID_OPACITY * (distancePercentage / 100);

            if (distancePercentage === 100) {
              this.state = STATE.OPEN;
            } else if (distancePercentage === 0) {
              this.state = STATE.CLOSED;
            } else {
              this.state = STATE.PANNING;
            }

            this.$el.style.left = `${moveDistance}px`;
            this.$el.style.touchAction = 'pan-x';
            this.backdropEl.style.opacity = opacity;
          } else if (direction === null) {
            if (event.cancelable) {
              event.preventDefault();
            }
          }

          raf = true;
        });
      },

      touchEnd() {
        requestAnimationFrame(() => {
          this.$el.style.touchAction = '';

          const position = parseInt(window.getComputedStyle(this.$el).getPropertyValue('left'));
          if (position > -(width * 0.75)) {
            this._openSidebar(position);
          } else {
            this._closeSidebar(position);
          }

          this.$el.classList.remove('og-sidebar--has-touch');
          this._cleanupListeners();
          raf = false;
        });
      },

      _openSidebar() {
        if (this.state === STATE.OPEN || this.state === STATE.OPENING) {
          this._updateMobileState(true);

          return;
        }

        this.state = STATE.OPENING;

        if (window.innerWidth <= 767) {
          gsap.to(this.$el, {
            duration: ANIMATION_DURATION,
            left: 0,
            onComplete: () => {
              this.state = STATE.OPEN;
              this.$el.classList.remove('og-sidebar--has-touch');
              this._updateMobileState(true);
            },
          });

          this.backdropEl.style.display = 'block';
          gsap.to(this.backdropEl, { opacity: SOLID_OPACITY, duration: ANIMATION_DURATION });
        } else {
          this.backdropEl.style.display = 'none';
        }
      },

      _closeSidebar() {
        if (this.state === STATE.CLOSED || this.state === STATE.CLOSING) {
          if (this.state === STATE.CLOSED) {
            // If the user fully closed the sidebar manually, fix backdrop.
            this.backdropEl.style.display = 'none';
          }

          this._updateMobileState(false);
          return;
        }

        this.$emit('fullClose');

        this.state = STATE.CLOSING;
        raf = false;

        gsap.to(this.$el, {
          duration: ANIMATION_DURATION,
          left: -width,
          onComplete: () => {
            this.state = STATE.CLOSED;

            this.$el.classList.remove('og-sidebar--has-touch');
            this.backdropEl.style.display = 'none';

            this._cleanupListeners();
            this._updateMobileState(false);
          },
        });

        gsap.to(this.backdropEl, { opacity: 0, duration: ANIMATION_DURATION });
      },

      _cleanupListeners() {
        if (moveListenerBound) {
          removeEventListener(document, 'touchmove', this.touchMove);
          moveListenerBound = false;
        }

        if (endListenerBound) {
          removeEventListener(document, 'touchend', this.touchEnd);
          endListenerBound = false;
        }
      },

      _updateMobileState(isOpen) {
        this.sidebarStore.updateMobileOpen(isOpen);
      },
    },
  };
</script>
